// src/App.tsx
import './App.css';
import { useEffect, useState } from 'react';
import { PublicClientApplication, AccountInfo } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./auth/authconfig";

import Main_Section_Banner from './App/Main_Section_Banner';
import Candidate_Page1 from './Pages/Candidate_Page1';
import Page_Login from './App/Page_Login';
import askMeImageOrange from './Images/askme_orange.png';
import ChatButton from './App/Main_Navigation_ChatButton';
import ChatCopilot from './App/Main_Navigation_ChatCopilot';
import Forgot_Password from './App/Forgot_Password';
import Main_Navigation_Title from './App/Main_Navigation_Title';
import { selfRegistration } from './Services/SelfRegistration';
import Page_Registration_Login from './Pages/Page_Registration_Login';
import { loginCandidate, LoginResponse } from './Requests/Get_AuthAPI';
import Component_Landscape_Prompt from './Components/Component_Landscape_Prompt';
import Component_Popup_Alert from './Components/Reschedule_Alert_Popup';
import Component_Link_Otp_Popup from './Components/Component_Link_Otp_Popup';



const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const [isInitialized, setIsInitialized] = useState(false);
  const [account, setAccount] = useState<AccountInfo | null>(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState<string>("candidatePage");
  const [currentPageText, setCurrentPageText] = useState<string>("Interview scheduling hub");
  const [candidateEmail, setCandidateEmail] = useState<string>("");
  const [primaryEmail, setPrimaryEmail] = useState<string>("");

  const [cancelledInterview, setCancelledInterview] = useState(false);
  const [completedInterview, setCompletedInterview] = useState(false);
  const [duplicateEmail, setDuplicateEmail] = useState<boolean>(false);


  const [isExperienced, setIsExperienced] = useState<boolean>(false);
  const [isCampus, setIsCampus] = useState<boolean>(false);

  const [candidatePageRefresh, setCandidatePageRefresh] = useState(0);
  const [showRegistration, setShowRegistration] = useState<boolean>(false);
  const [hasInitiatedRedirect, setHasInitiatedRedirect] = useState<boolean>(false);

  // Add this state near your other useState declarations
  const [showUnauthorizedAlert, setShowUnauthorizedAlert] = useState(false);
  const [unauthorizedMessage, setUnauthorizedMessage] = useState("");
  const [isPanel, setIsPanel] = useState<boolean>(false);
  const [otpRequired, setOtpRequired] = useState<boolean>(false);
  const [maskedEmail, setMaskedEmail] = useState<string>("");
  const [loginRetry, setLoginRetry] = useState<number>(0);


  const normalizeEmail = (email: string): string => {
    return email?.trim().toLowerCase() || '';
  };

  useEffect(() => {
    // Initialize MSAL before doing anything
    const init = async () => {
      await msalInstance.initialize();

      const response = await msalInstance.handleRedirectPromise();
      if (response && response.account) {
        msalInstance.setActiveAccount(response.account);
        setAccount(response.account);
        setCandidateEmail(normalizeEmail(response.account.username));
        console.log("candidate email:", candidateEmail);
      } else {
        const current = msalInstance.getActiveAccount();
        if (current) {
          setAccount(current);
          setCandidateEmail(normalizeEmail(current.username));
        }
      }
      setIsInitialized(true);
    };
    init();
  }, []);

  useEffect(() => {
    const fetchCandidate = async () => {
      if (!candidateEmail) return;
      const normalizedEmail = normalizeEmail(candidateEmail);

      const typedPrimary = sessionStorage.getItem('typed_primary_email') ?? '';
      const res = await loginCandidate(normalizedEmail, typedPrimary).catch((): LoginResponse => ({ ok: false }));
      if (res.otp_required) {
        setMaskedEmail(res.masked_email ?? '');
        setOtpRequired(true);
        return;
      }
      if (res.ok) {
        sessionStorage.removeItem('typed_primary_email');
        setPrimaryEmail(normalizeEmail(res.data?.primary_email) || normalizedEmail);
        const interviewStatus = res.data?.interview_status?.toLowerCase();
        const is_experienced = res.data?.is_experienced;
        const is_duplicate = res.data?.duplicate_application;

        const is_panel = res.data?.is_panel;
        setIsPanel(is_panel ?? false);

        setIsExperienced(is_experienced);
        setIsCampus(!is_experienced);
        if (interviewStatus === 'cancelled') {
          setCancelledInterview(true);
        }

        else if (interviewStatus === 'completed') {
          setCompletedInterview(true);
        }

        else {
          setCancelledInterview(false);
          setCompletedInterview(false);
        }
        if (is_duplicate) {
          setDuplicateEmail(true);
        }
        setCurrentPage('candidatePage');
      } else {
        // User not found in system
        setUnauthorizedMessage("You are not authorized to access this application. Please verify you are using the correct email address.");
        setShowUnauthorizedAlert(true);
      }

      console.log("candidate email updated:", candidateEmail);
    };

    fetchCandidate();
  }, [candidateEmail, loginRetry]);


  // Removed auto-redirect - let user choose login from registration page

  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const [registrationEmail, setRegistrationEmail] = useState("")

  const handleLogout = async () => {
    const active = msalInstance.getActiveAccount();
    if (active) {
      await msalInstance.logoutRedirect({ account: active });
    }
  };

  const pageRouter = (page: string) => {
    switch (page) {
      // case 'LoginPage':
      //   return <Page_Login setCurrentPage = {setCurrentPage} setCandidateEmail= {setCandidateEmail} setCancelledInterview = {setCancelledInterview} setCompletedInterview={setCompletedInterview} setIsExperienced={setIsExperienced} setIsCampus={setIsCampus}/>;

      // case 'ForgotPassword':
      //   return <Forgot_Password setCurrentPage={setCurrentPage} setCandidateEmail={setCandidateEmail} />;
      case 'candidatePage':
        return <Candidate_Page1 candidateEmail={primaryEmail} setCandidateEmail={setCandidateEmail} cancelledInterview={cancelledInterview} setCancelledInterview={setCancelledInterview} refreshTrigger={candidatePageRefresh} completedInterview={completedInterview} setCompletedInterview={setCompletedInterview} isExperienced={isExperienced} setIsExperienced={setIsExperienced} isCampus={isCampus} setIsCampus={setIsCampus} duplicateEmail={duplicateEmail} isPanel={isPanel}
          setIsPanel={setIsPanel} />;
      default:
        return <div>"In Progress"</div>;
    }
  };

  const changePage = (page: string, pageText: string) => {
    setCurrentPage(page);
    setCurrentPageText(pageText);
  };

  // Wait for MSAL initialization before showing anything
  if (!isInitialized) {
    return <div>Loading your dashboard</div>;
  }

  // Show registration page if user not logged in
  if (!account) {
    return (
      <Page_Registration_Login
        onLoginRedirect={async (typedEmail: string) => {
          setShowRegistration(false);
          sessionStorage.setItem('typed_primary_email', normalizeEmail(typedEmail));
          try {
            await msalInstance.loginRedirect(loginRequest);
          } catch (error) {
            console.error('Microsoft login failed:', error);
          }
        }}
      />
    );
  }

  // Once logged in → render app
  return (
    <><Component_Landscape_Prompt />
      {otpRequired && (
        <Component_Link_Otp_Popup
          maskedEmail={maskedEmail}
          onVerified={() => { setOtpRequired(false); setLoginRetry(n => n + 1); }}
          onCancel={async () => { setOtpRequired(false); sessionStorage.removeItem('typed_primary_email'); await handleLogout(); }}
        />
      )}
      <div className='main-container'>
        <div className='main-frame-section'>
          <div className='title-section'>
            <Main_Navigation_Title
              heading='Candidate Dashboard'
              setCurrentPage={setCurrentPage}
              candidateEmail={primaryEmail} />
          </div>
          {!(cancelledInterview || completedInterview) && (
            <>
              <ChatButton
                onClick={() => setIsChatOpen(true)}
                isOpen={isChatOpen} />

              <ChatCopilot
                isOpen={isChatOpen}
                onClose={() => {
                  setIsChatOpen(false);
                  console.log("Refreshed to candidate page");

                  setCandidatePageRefresh(prev => prev + 1);
                  window.location.reload();
                }}
                iconImage={askMeImageOrange}
                userType="recruiter"
                candidateEmail={primaryEmail} />
            </>
          )}

          <div className='content-frame-section'>
            <div className='content-section'>
              <div className='content-banner-section'>
                <div className='content-banner-padding'></div>
                <div className='content-banner'>
                  <Main_Section_Banner heading={currentPageText} />
                </div>
                <div className='content-banner-padding'></div>
              </div>
              <div className='content-main-section'>
                <div className='content-main-padding'></div>
                <div className='content-main'>{pageRouter(currentPage)}</div>
                <div className='content-main-padding'></div>
              </div>
              <div className='footer-section'>
                <div className='footer'>
                  <p>© 2026 PwC US. All rights reserved. PwC US refers to the US group of member firms, and may sometimes refer to the PwC network. Each member firm is a separate legal entity.
                    <a
                      href="https://privacyhub.pwc.com/us/en/candidate-interview-scheduler/privacy-policy.html"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "black" }}
                    >
                      <strong><u> Privacy Statement</u></strong>  </a> </p>

                </div>
              </div>
            </div>
          </div>
        </div>
        <Component_Popup_Alert
          isOpen={showUnauthorizedAlert}
          onClose={async () => {
            setShowUnauthorizedAlert(false);
            await handleLogout();
          }}
          message={unauthorizedMessage}
          title="Unauthorized Access"
        />
      </div></>
  );
}

export default App;